// Importar dependencias
import ApiClient from "./ApiClient";

const businessUrl = "businesses/";

// Funcion para crear un usuario
async function createUser(data) {
  // Realizar peticion al servidor para crear datos
  try {
    const result = await ApiClient.post(`users/employee/sign-up`, data);
    return result.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Obtiene un usuario por su id
async function getEmployeeById(employeeId) {
  try {
    const user = await ApiClient.get(`users/${employeeId}`);
    return user.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Actualizar un employee
async function updateEmployee(id, data) {
  try {
    const updateUser = await ApiClient.post(
      `users/employee/${id}/update-profile`,
      data
    );

    return updateUser.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Funcion para obtener todos los usuarios de una sucursal
async function getUsersByBusiness(businessId, page) {
  try {
    // Generar una petición para obtener usuarios
    const usersResult = await ApiClient.get(
      businessUrl + businessId + "/employees" + "?page=" + page
    );

    return usersResult.data;
  } catch (err) {
    // Lanzar error
    throw new Error(err.response.data.message);
  }
}

// función para eliminar un empleado
async function deleteEmployee(employeeId) {
  try {
    const employee = await ApiClient.post(
      `users/employee/${employeeId}/deactivate`
    );
    return employee;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Función para empezar el oboarding de Stripe
async function startOnboarding() {
  try {
    // Generar una petición para obtener usuarios
    const result = await ApiClient.post(`users/onboard-user`);

    return result.data;
  } catch (err) {
    // Lanzar error
    throw new Error(err.response.data.message);
  }
}

// Obtiene el balance de la cuenta de un usuario
async function getBalance() {
  try {
    // Generar una petición para obtener usuarios
    const result = await ApiClient.post(`users/balance`);

    return result.data;
  } catch (err) {
    // Lanzar error
    throw new Error(err.response.data.message);
  }
}

// Actualizar datos del usuario
async function updateMercadoPagoData(mercadoPagoData) {
  try {
    // Actualizar datos
    const result = await ApiClient.post(`users/mercadopago`, mercadoPagoData);
    return result.data;
  } catch (Err) {
    // Lanzar error
    throw new Error(err.response.data.message);
  }
}

export default {
  getUsersByBusiness,
  createUser,
  getEmployeeById,
  updateEmployee,
  deleteEmployee,
  startOnboarding,
  updateMercadoPagoData,
  getBalance
};
